"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootScene = void 0;
var GameManager_1 = require("../GameManager");
var GameVars_1 = require("../GameVars");
var BootScene = /** @class */ (function (_super) {
    __extends(BootScene, _super);
    function BootScene() {
        return _super.call(this, "BootScene") || this;
    }
    BootScene.prototype.preload = function () {
        this.load.atlas("texture_atlas_0", "assets/texture_atlas_0.png", "assets/texture_atlas_0.json");
    };
    BootScene.prototype.create = function () {
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Bubblegum", fontSize: 28, color: "#A6F834" });
        this.add.text(-100, -100, "abcdefg", { fontFamily: "Baloo", fontSize: 28, color: "#A6F834" });
        BootScene.currentInstance = this;
        GameManager_1.GameManager.setCurrentScene(this);
        if (!GameVars_1.GameVars.isDesktop) {
            var w = window.innerWidth;
            var h = window.innerHeight;
            if (w < h) {
                BootScene.bootedInWrongOrientation = false;
                GameManager_1.GameManager.init();
            }
            else {
                BootScene.bootedInWrongOrientation = true;
                document.getElementById("orientation").style.display = "block";
                document.getElementById("content").style.display = "none";
            }
        }
        else {
            GameManager_1.GameManager.init();
        }
    };
    return BootScene;
}(Phaser.Scene));
exports.BootScene = BootScene;
